import { useContractsSimpleQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "../store";

export const useFetchContractsOptions = (): boolean => {
  const store = useStore();

  const { loading, refetch } = useContractsSimpleQuery({
    variables: { contractorId: store.form.contractor_id.value },
    skip: !store.form.contractor_id.value,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      store.setContractsOptions(data);
    },
    ...onError(),
  });

  store.refetchContractsOptions = refetch;

  return loading;
};
